import React from 'react';

export const IDealWeroSquare = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 295 295">
    <defs>
      <linearGradient id="A" x1="152.7" y1="245.84" x2="130.19" y2="273.41" gradientUnits="userSpaceOnUse">
        <stop offset=".02" stopColor="#1d1c1c" stopOpacity="0" />
        <stop offset=".68" stopColor="#1d1c1c" />
      </linearGradient>
      <linearGradient id="B" x1="113.43" y1="251.69" x2="136.51" y2="228.88" gradientUnits="userSpaceOnUse">
        <stop offset=".02" stopColor="#1d1c1c" stopOpacity="0" />
        <stop offset=".68" stopColor="#1d1c1c" />
      </linearGradient>
    </defs>
    <rect width="295" height="295" rx="13" fill="#fff48d" />
    <path
      d="M56.51 22.87v136.4c0 6.53 5.37 11.87 11.93 11.87h81.89c61.91 0 88.74-34.49 88.74-80.25S212.23 11 150.32 11H68.43c-6.56 0-11.93 5.34-11.93 11.87z"
      fill="#fff"
    />
    <path
      d="M111.32,44.48v100.79h44.07c40.02,0,57.37-22.5,57.37-54.31s-17.36-54.07-57.37-54.07h-36.44c-4.23,0-7.63,3.44-7.63,7.6Z"
      fill="#c06"
    />
    <g fillRule="evenodd">
      <path
        d="M79.11 160.28h71.21c50.04 0 77.65-24.63 77.65-69.33 0-25.76-10.08-69.03-77.65-69.03H79.11c-6.32 0-11.45 5.1-11.45 11.4v115.57c0 6.29 5.13 11.4 11.45 11.4zM71.47 33.32c0-4.21 3.4-7.6 7.63-7.6h71.21c27.55 0 73.83 8.49 73.83 65.23 0 42.26-26.24 65.53-73.83 65.53H79.1c-4.23 0-7.63-3.38-7.63-7.6V33.32z"
        fill="#232323"
      />
      <path
        d="M133.01 76.3c-1.34-.48-2.74-.72-4.26-.72v-.06h-10.09v24.34h10.21c1.81 0 3.38-.36 4.72-.96 1.34-.66 2.45-1.5 3.33-2.58s1.52-2.4 1.98-3.9c.41-1.5.64-3.12.64-4.92 0-2.04-.29-3.78-.82-5.28-.58-1.44-1.34-2.7-2.27-3.72-.99-.96-2.1-1.74-3.44-2.22zm-2.4 18.77a7.16 7.16 0 0 1-2.22.36v.06h-4.61V80.14h3.73c1.28 0 2.33.18 3.21.54s1.57.96 2.1 1.62.93 1.56 1.17 2.52c.23.96.35 2.1.35 3.3 0 1.38-.18 2.46-.52 3.42a7.12 7.12 0 0 1-1.34 2.28 4.38 4.38 0 0 1-1.87 1.26z"
        fill="#fff"
      />
    </g>
    <path d="M160.6 75.59v4.5h-12.49v5.22h11.49v4.14h-11.49v5.94h12.78v4.5h-17.97V75.55h17.68v.06z" fill="#fff" />
    <path
      d="M187.32,99.93l-8.87-24.34h-5.43l-8.93,24.34h5.25l1.87-5.4h8.87l1.81,5.4h5.43ZM175.77,81.58l2.98,8.93h-6.13l3.09-8.93h.06Z"
      fillRule="evenodd"
      fill="#fff"
    />
    <path d="M195.78 75.58v19.85h11.55v4.5h-16.74V75.59h5.19z" fill="#fff" />
    <path
      d="M90.84 100.29c6.32 0 11.44-5.12 11.44-11.45s-5.12-11.45-11.44-11.45S79.4 82.51 79.4 88.84s5.12 11.45 11.44 11.45zm6.81 45.79c-8.86 0-15.96-7.65-15.96-17.05v-13.31c0-4.7 3.55-8.56 8.01-8.56s8.01 3.8 8.01 8.56v30.36h-.06z"
      fill="#232323"
    />
    <path
      d="M258 199H38c-1.1 0-2-.9-2-2s.9-2 2-2h220c1.1 0 2 .9 2 2s-.9 2-2 2zm-52.42 49.76c0-13.38 9.52-25.57 25.96-25.57s26.03 12.2 26.03 25.57-9.52 25.57-26.03 25.57c-16.44 0-25.96-12.2-25.96-25.57zm37.54 0c0-6.45-4.25-12.4-11.58-12.4s-11.58 5.96-11.58 12.4 4.32 12.41 11.58 12.41 11.58-5.96 11.58-12.41zm-47.65 9.5c5.48-3.12 8.77-9.08 8.77-15.66 0-9.77-7.06-18.09-18.02-18.09h-23.01v48.51h14.25v-12.4h2.67l8.15 12.4h16.78l-9.59-14.76zm-12.12-8.8h-5.89v-13.72h5.96c3.84 0 6.3 3.12 6.3 6.86s-2.54 6.86-6.37 6.86zm-85.18-25l-8.55 28.91-8.34-28.91H69.93l-8.41 28.91-8.48-28.91H38l17.23 48.42h12.38l8-26.36 7.93 26.36h12.44l17.23-48.42H98.17zm36.6 36.59h-.04c-5.33 0-9.07-3.22-10.67-7.48h36.21c.29-1.6.44-3.24.44-4.9 0-13.34-9.49-25.51-25.95-25.52v13.14c5.36.01 9.06 3.23 10.65 7.48h-36.16c-.29 1.6-.44 3.24-.44 4.9 0 13.35 9.5 25.53 25.91 25.53h.04v-13.15z"
      fill="#1d1c1c"
    />
    <path
      d="M134.73 274.19l1.65-.04c3.33-.17 6.36-.85 9.06-1.94 2.7-1.1 5.07-2.6 7.08-4.42a24.19 24.19 0 0 0 4.97-6.3c1.17-2.13 2.03-4.45 2.57-6.86h-15.09a12.39 12.39 0 0 1-1.08 1.83c-.56.79-1.22 1.5-1.97 2.11a10.51 10.51 0 0 1-2.51 1.54c-.93.4-1.93.68-3.02.83a12.58 12.58 0 0 1-1.65.11c-3.4 0-6.14-1.31-8.1-3.36l-9.81 9.92c4.36 4.03 10.41 6.57 17.91 6.57z"
      fill="url(#A)"
    />
    <path
      d="M134.73,223.14c-13.92,0-22.87,8.76-25.26,19.56h15.04c1.8-3.72,5.34-6.42,10.22-6.42,3.89,0,6.91,1.68,8.88,4.22l9.9-10.01c-4.42-4.48-10.78-7.35-18.77-7.35Z"
      fill="url(#B)"
    />
  </svg>
);
